import PropTypes from 'prop-types'
import { useAuth } from './AuthContext'
import { Navigate } from 'react-router-dom'

const ProtectedRoute = ({ children, requiredPermission = null }) => {
  const { user } = useAuth()

  if (!user) {
    return <Navigate to='/login' replace />
  }

  if (requiredPermission && !user.permissions?.includes(requiredPermission)) {
    return <Navigate to='/dashboard' replace />
  }

  return children
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  requiredPermission: PropTypes.number
}

export default ProtectedRoute
